import { render, staticRenderFns } from "./AgentGreeting.vue?vue&type=template&id=053ddcda"
import script from "./AgentGreeting.vue?vue&type=script&lang=js"
export * from "./AgentGreeting.vue?vue&type=script&lang=js"
var disposed = false

function injectStyles (context) {
  if (disposed) return
  
}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/ecommerce/videochat-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('053ddcda')) {
      api.createRecord('053ddcda', component.options)
    } else {
      api.reload('053ddcda', component.options)
    }
    module.hot.accept("./AgentGreeting.vue?vue&type=template&id=053ddcda", function () {
      api.rerender('053ddcda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ChatContent/Header/AgentGreeting.vue"
export default component.exports